
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';
import { Battery, Signal, Zap, Activity } from 'lucide-react';

interface SmartMeterMetricsProps {
  device: any;
}

const SmartMeterMetrics: React.FC<SmartMeterMetricsProps> = ({ device }) => {
  return (
    <>
      <Card>
        <CardContent className="p-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-sm font-medium">Battery Level</p>
              <h3 className="text-2xl font-bold mt-1">{device.batteryLevel}%</h3>
            </div>
            <div className={cn(
              "rounded-full p-2",
              device.batteryLevel > 70 ? "bg-green-100 dark:bg-green-900/30" :
              device.batteryLevel > 30 ? "bg-amber-100 dark:bg-amber-900/30" : "bg-red-100 dark:bg-red-900/30"
            )}>
              <Battery className={cn(
                "h-5 w-5",
                device.batteryLevel > 70 ? "text-green-600 dark:text-green-400" :
                device.batteryLevel > 30 ? "text-amber-600 dark:text-amber-400" : "text-red-600 dark:text-red-400"
              )} />
            </div>
          </div>
          <Progress 
            value={device.batteryLevel} 
            className="h-2 mt-4" 
          />
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-sm font-medium">Signal Strength</p>
              <h3 className="text-2xl font-bold mt-1">{device.signalStrength}%</h3>
            </div>
            <div className={cn(
              "rounded-full p-2",
              device.signalStrength > 70 ? "bg-green-100 dark:bg-green-900/30" :
              device.signalStrength > 30 ? "bg-amber-100 dark:bg-amber-900/30" : "bg-red-100 dark:bg-red-900/30"
            )}>
              <Signal className={cn(
                "h-5 w-5",
                device.signalStrength > 70 ? "text-green-600 dark:text-green-400" :
                device.signalStrength > 30 ? "text-amber-600 dark:text-amber-400" : "text-red-600 dark:text-red-400"
              )} />
            </div>
          </div>
          <Progress 
            value={device.signalStrength} 
            className="h-2 mt-4" 
          />
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-sm font-medium">Power Reading</p>
              <h3 className="text-2xl font-bold mt-1">{device.readings.power.toFixed(1)} W</h3>
            </div>
            <div className="rounded-full bg-blue-100 p-2 dark:bg-blue-900/30">
              <Zap className="h-5 w-5 text-blue-600 dark:text-blue-400" />
            </div>
          </div>
          <div className="flex justify-between text-xs text-muted-foreground mt-4">
            <span>Voltage: {device.readings.voltage}V</span>
            <span>Current: {device.readings.current}A</span>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-sm font-medium">Total Energy</p>
              <h3 className="text-2xl font-bold mt-1">{device.readings.totalEnergy.toFixed(1)} kWh</h3>
            </div>
            <div className="rounded-full bg-green-100 p-2 dark:bg-green-900/30">
              <Activity className="h-5 w-5 text-green-600 dark:text-green-400" />
            </div>
          </div>
          <div className="flex justify-between text-xs text-muted-foreground mt-4">
            <span>Frequency: {device.readings.frequency} Hz</span>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default SmartMeterMetrics;
